<template>
  <div>
    <label class="mb-3"  for="sessions-select">Select Range of Sessions for Data Export:</label>
    <div class="session-range-selector">
      <div v-for="rangeIndex in numRanges" :key="rangeIndex" class="session-range-input">
        <div class="filter-row mb-3">
          <span>From Session</span>
          <select class="filter-select form-control filter" v-model="sessionRanges[rangeIndex - 1].start">
            <option v-for="session in filteredSessions(rangeIndex, 'start')" :key="session.id" :value="session.index">
              {{ session.index }} - {{ session.id }} -  {{ session.date.toLocaleDateString("en-US", dateOptions) }},
              {{ session.movements[0] ? session.movements[0].name : "" }}
            </option>
          </select>
          <span>To Session</span>
          <select class="form-control filter" v-model="sessionRanges[rangeIndex - 1].end">
            <option v-for="session in filteredSessions(rangeIndex, 'end')" :key="session.id" :value="session.index">
              {{ session.index }} - {{ session.id }} - {{ session.date.toLocaleDateString("en-US", dateOptions) }},
              {{ session.movements[0] ? session.movements[0].name : "" }}
            </option>
          </select>
          <span @click="removeRangeByIndex(rangeIndex)" class="ml-1 text-btn" v-if="rangeIndex > 1"><i class="ri-delete-bin-line"></i></span>
        </div>
      </div>
     <div class="filter-actions mt-3">
        <button @click="addRange" class="add-filter-btn">+ Add Range</button>
        <div class="action-buttons">
           <button @click="clearRanges" class="btn action-btn mr-1">Clear All</button>
           <button
              @click="downloadSelectedRanges"
              class="btn action-btn apply-btn"
              :class="{ 'loading': downloadingRangeSessionsData }"
              :disabled="downloadingRangeSessionsData"
            >
              <span v-if="!downloadingRangeSessionsData">Download</span>
              <span v-else class="loading-spinner"></span>
            </button>
        </div>
     </div>
  </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import exportAsCSV from './functions/SaveAsCSV'

export default {
  name: 'SessionRangeSelector',
  props: {
    sessionsList: Array,
    userDevices: Array
  },
  setup (props, { emit }) {
    const { downloadSessionsAsZip, downloadingRangeSessionsData } = exportAsCSV()
    const numRanges = ref(1)
    const dateOptions = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }

    const sessionRanges = ref([{ start: null, end: null }])

    function addRange () {
      sessionRanges.value.push({ start: null, end: null })
      numRanges.value++
    }

    function removeRange (index) {
      sessionRanges.value.splice(index, 1)
      numRanges.value--
    }

    async function downloadSelectedRanges () {
      const selectedSessions = new Set()

      sessionRanges.value.forEach((range) => {
        if (range.start !== null && range.end !== null) {
          const start = props.sessionsList.length - range.start
          const end = props.sessionsList.length - range.end

          const startIndex = Math.min(start, end)
          const endIndex = Math.max(start, end)
          for (let i = startIndex; i <= endIndex; i++) {
            selectedSessions.add(props.sessionsList[i])
          }
        }
      })

      await downloadSessionsAsZip(selectedSessions, props.userDevices)
    }

    const clearRanges = () => {
      sessionRanges.value = [{ start: null, end: null }]
      numRanges.value = 1
    }

    const removeRangeByIndex = (index) => {
      sessionRanges.value.splice(index - 1, 1)
      numRanges.value--
    }

    const filteredSessions = (rangeIndex, type) => {
      return props.sessionsList.filter((session, index) => {
        if (type === 'start' && sessionRanges.value[rangeIndex - 1].end !== null) {
          return session.index <= sessionRanges.value[rangeIndex - 1].end
        } else if (type === 'end' && sessionRanges.value[rangeIndex - 1].start !== null) {
          return session.index >= sessionRanges.value[rangeIndex - 1].start
        }
        return true
      })
    }

    return {
      sessionRanges,
      addRange,
      removeRange,
      downloadSelectedRanges,
      clearRanges,
      removeRangeByIndex,
      downloadingRangeSessionsData,
      numRanges,
      filteredSessions,
      dateOptions
    }
  }
}
</script>

  <style scoped>
  .session-range-selector {
    color: #888;
    background-color: var(--light-grey);
    padding: 20px;
    border: 1px dashed var(--border-color);
    width: 95%;
  }
  .session-range-input {
    display: flex;
  }

  .filter.form-control {
    border-radius: 3px;
    font-size: 14px;
    height: fit-content;
    padding: 0 5px;
    line-height: 35px;
  }
  .filter-row {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    font-size: 13px !important;
  }

  .filter-row span {
    white-space: nowrap;
    margin-right: 8px;
  }

  .filter {
    flex: 1;
    margin-right: 8px;
  }

  .filter-select {
    min-width: 190px;
  }

  .action-btn {
    background-color: #e1e5e8;
    color: black;
    font-size: 13px !important;
  }
  .apply-btn {
  background-color: green;
  color: white;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 100px;
}

.apply-btn:hover {
  background-color: darkgreen;
  cursor: pointer;
  color: white
}

.action-btn:hover {
  color: var(--accent-color);
}

.loading {
  cursor: not-allowed;
}

.loading-spinner {
  border: 2px solid #f3f3f3;
  border-top: 2px solid #3498db;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

  .add-filter-btn {
    background-color: transparent;
    color: rgb(33, 183, 33);
    border: none;
    margin-left: 0;
    font-size: 13px;
  }

  .filter-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid var(--border-color);
    padding-top: 15px;
  }

  .text-btn {
        cursor: pointer;
        padding: 0;
        margin: 0;
    }

  </style>
